import {type UseFormSetValue} from "react-hook-form";
import {type TypeGroupPair, type Configuration} from "../types";

export const selectAll =
  (
    typeGroupEntries: Array<[string, boolean]>,
    setValue: UseFormSetValue<Configuration>,
    unavailableTypeGroupPairs: TypeGroupPair[]
  ) =>
  () => {
    typeGroupEntries.forEach(([key, _]) => {
      const [, typeId, , groupId] = key.split("_");
      if (
        !unavailableTypeGroupPairs.some(
          pair => `${pair.typeId}` === typeId && `${pair.groupId}` === groupId
        )
      ) {
        setValue(key as keyof Configuration, true, {
          shouldValidate: true
        });
      }
    });
  };

export const deselectAll =
  (
    typeGroupEntries: Array<[string, boolean]>,
    setValue: UseFormSetValue<Configuration>,
    clearValidationErrors: () => void,
    unavailableTypeGroupPairs: TypeGroupPair[]
  ) =>
  () => {
    typeGroupEntries.forEach(([key, _]) => {
      const [, typeId, , groupId] = key.split("_");
      if (
        !unavailableTypeGroupPairs.some(
          pair => `${pair.typeId}` === typeId && `${pair.groupId}` === groupId
        )
      ) {
        setValue(key as keyof Configuration, false, {
          shouldValidate: true
        });
      }
    });

    clearValidationErrors();
  };
